var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-detail-page page-max-width"},[_c('MatchDetailHeroSection',{attrs:{"hero-data":_vm.matchDetailHeroData}}),_c('MatchDetailScheduleSection',{attrs:{"schedule-data":_vm.matchDetailScheduleData,"schedule-list":_vm.matchDetailScheduleList}}),_c('MatchDetailRulesSection'),_c('MatchPageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }